import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Invitation from "@/pages/Invitation";
import CardPage from "@/pages/CardPage";
import Host from "@/pages/Host";
import { http } from "@/lib/api";

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    http
      .post("/auth/session", {}, { headers: { "X-Session-ID": sid } })
      .then((r) => navigate("/host", { replace: true, state: { user: r.data } }))
      .catch((e) => navigate("/host", { replace: true, state: { authError: e?.response?.data?.detail || "Sign in failed. Please try again." } }));
  }, [location.hash, navigate]);
  return <div className="min-h-screen emerald-cloth" />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Invitation />} />
      <Route path="/card/:cardId" element={<CardPage />} />
      <Route path="/host" element={<Host />} />
      <Route path="*" element={<Invitation />} />
    </Routes>
  );
}

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </MotionConfig>
  );
}
